import styled from 'styled-components';
import { Typography } from '@material-ui/core';

export const AuthCardTitle = styled(Typography).attrs({ variant: 'h6' })`
  && {
    display: flex;
    justify-content: center;
    font-weight: bold;
  }
`;

export const AuthCardSubTitle = styled(Typography)`
  && {
    display: flex;
    justify-content: center;
    font-weight: 300;
    margin: 20px 0;
  }
`;

export const InfoSection = styled.div`
  background-color: ${props => props.theme.palette.primary['500']};
  width: 410px;
  margin-left: 20px;
  @media (max-width: 990px) {
    display: none;
  }
`;

export const Divider = styled.div`
  color: ${props => props.theme.palette.primary['500']};
  text-align: center;
  margin: 30px 50px;
  position: relative;
  &:before {
    content: '';
    width: 40%;
    position: absolute;
    top: 50%;
    left: 0;
    height: 1px;
    background-color: ${props => props.theme.palette.primary['500']};
    opacity: 0.4;
  }
  &:after {
    content: '';
    width: 40%;
    position: absolute;
    top: 50%;
    right: 0;
    height: 1px;
    background-color: ${props => props.theme.palette.primary['500']};
    opacity: 0.4;
  }
`;

export const LinkContainer = styled.span`
  color: ${props => props.theme.primary};
  text-decoration: underline;
  text-align: right;
  display: block;
  font-size: 12px;
  margin: 10px 0 30px 0;
  & span {
    cursor: pointer;
  }
`;
